/**
 * Swing `JOptionPane.showInputDialog`: Enter activates the default OK button
 * unless focus is already on another control that consumes it (a footer button,
 * a textarea, a link, or a select).
 */
export function shouldConfirmInputDialogOnEnter(event: {
  key: string
  isComposing?: boolean
  target?: EventTarget | null
}): boolean {
  if (event.isComposing) return false
  if (event.key !== 'Enter' && event.key !== 'NumpadEnter') return false
  const target = event.target as { closest?: (selector: string) => unknown } | null
  if (target && typeof target.closest === 'function') {
    if (target.closest('button, textarea, a, select, [contenteditable="true"]')) {
      return false
    }
  }
  return true
}
